if (!customElements.get('faq-navigation')) {
  customElements.define('faq-navigation', class extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.faq');
      this.links = Array.from(this.querySelectorAll('.faq--category-header'));
      this.anchors = Array.from(section.querySelectorAll('.faq--category-anchor'));
      if (!this.links.length || !this.anchors.length) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.queueUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };

      this.addEventListener('click', (event) => {
        const link = event.target.closest('.faq--category-header');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = this.anchors.find((anchor) => `#${anchor.id}` === link.hash);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          block: 'start'
        });
        if (window.location.hash !== link.hash) history.pushState(null, '', link.hash);
        this.setActive(link.hash);
      }, options);
      window.addEventListener('scroll', this.queueUpdate, { ...options, passive: true });
      window.addEventListener('resize', this.queueUpdate, options);
      window.addEventListener('hashchange', () => {
        if (this.links.some((link) => link.hash === window.location.hash)) {
          this.setActive(window.location.hash);
        }
      }, options);
      this.observer = new ResizeObserver(this.queueUpdate);
      this.observer.observe(section.querySelector('.faq--container--questions'));
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    update() {
      const offset = parseFloat(getComputedStyle(this.anchors[0]).scrollMarginTop) || 100;
      let active = this.anchors[0];
      for (const anchor of this.anchors) {
        if (anchor.getBoundingClientRect().top <= offset + 1) active = anchor;
      }
      // The final heading may not reach the top when the page runs out of scroll.
      if (window.scrollY > 0 && window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2) {
        active = this.anchors[this.anchors.length - 1];
      }
      this.setActive(`#${active.id}`);
    }

    setActive(hash) {
      this.links.forEach((link) => {
        const active = link.hash === hash;
        link.classList.toggle('active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
  });
}
